module.exports = __webpack_public_path__ + "img/47.7.Chla.d0fdd620.png";